import { render } from "./DashboardItem.vue?vue&type=template&id=745b93ac&scoped=true"
import script from "./DashboardItem.vue?vue&type=script&lang=js"
export * from "./DashboardItem.vue?vue&type=script&lang=js"

import "./DashboardItem.vue?vue&type=style&index=0&id=745b93ac&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-745b93ac"]])

export default __exports__